import React from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import MobileSlides from "./MobileSlides";
import SectionOne from "./Sectionone";
import "./home.scss";

export default function SimpleSlider() {
	var settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000
	};
	const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
	if (isMobile) {
		console.log("mobile is working");
		return (
			<Slider {...settings} style={{ overflow: "hidden" }}>
				<div>
					<MobileSlides
						background={
							"https://res.cloudinary.com/ggi/image/upload/v1637903387/Blue-Diamonds-Buying-Guide_so4mja.webp"
						}
					/>
				</div>
			</Slider>
		);
	} else {
		return (
			<Slider {...settings} style={{ overflow: "hidden" }}>
				<div>
					<SectionOne
						background={
							"https://res.cloudinary.com/ggi/image/upload/v1637903387/Blue-Diamonds-Buying-Guide_so4mja.webp"
						}
						time={500}
					/>
				</div>
				<div>
					<SectionOne
						background={
							"https://res.cloudinary.com/ggi/image/upload/v1637903441/sl1_j3riop.webp"
						}
						time={2000}
					/>
				</div>
				<div>
					<SectionOne
						background={
							"https://res.cloudinary.com/ggi/image/upload/v1637903426/gem-testing_suqakz.webp"
						}
						time={3000}
					/>
				</div>
				<div>
					<SectionOne
						background={
							"https://res.cloudinary.com/ggi/image/upload/v1637903387/Blue-Diamonds-Buying-Guide_so4mja.webp"
						}
						time={3000}
						paragraph={"Find Best For You"}
						heading={
							<h2 data-aos="fade-down">
								Find Your
								<br />
								<span data-aos="fade-right">Birth Stone </span>
								<br /> With Our Experts
							</h2>
						}
						more={"/gemology/YourBirthStone"}
					/>
				</div>
			</Slider>
		);
	}
}
